import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, ApiService } from '../api/api.service';

export interface OrderdirectInvoice {
    id: number;
    od_bon_nr: string;
    od_bon_datum: string | null;
    od_deb_nr: string | null;
    od_prijs_verk: string | null;
    od_deb_naam: string | null;
    afas_debtor_id: number | null;
    exception: string | null;
    execute_at: string | null;
    failed_at: string | null;
    data: any;
    afas_ornu: string | null;
    afas_liin: string | null;
    afas_balance: string | null;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
}

export interface OrderdirectInvoiceParams {
    per_page?: number;
    page?: number;
    status?: 'new' | 'pending' | 'completed' | 'failed';
    from_date?: string;
    to_date?: string;
    search?: string;
}

export interface PaginatedResponse<T> {
    current_page: number;
    data: T[];
    first_page_url: string;
    from: number;
    last_page: number;
    last_page_url: string;
    next_page_url: string | null;
    path: string;
    per_page: number;
    prev_page_url: string | null;
    to: number;
    total: number;
}

@Injectable({
    providedIn: 'root',
})
export class OrderdirectInvoiceService {
    constructor(private apiService: ApiService) {}

    triggerSync() {
        return this.apiService.postCall$<ApiResponse<string>>('orderdirect-invoices/sync', {});
    }

    getInvoices(params?: OrderdirectInvoiceParams): Observable<ApiResponse<PaginatedResponse<OrderdirectInvoice>>> {
        return this.apiService.getCallObs<ApiResponse<PaginatedResponse<OrderdirectInvoice>>>(
            'orderdirect-invoices',
            params || {}
        );
    }

    getInvoiceById(id: number): Observable<ApiResponse<OrderdirectInvoice>> {
        return this.apiService.getCallObs<ApiResponse<OrderdirectInvoice>>(`orderdirect-invoices/${id}`);
    }

    sendToAfas(id: number): Observable<ApiResponse<any>> {
        return this.apiService.postCall$<ApiResponse<any>>(`orderdirect-invoices/send-to-afas/${id}`, {});
    }

    sendAllToAfas(params?: OrderdirectInvoiceParams): Observable<ApiResponse<any>> {
        return this.apiService.postCall$<ApiResponse<any>>('orderdirect-invoices/send-all-to-afas', params || {});
    }

    resetStatus(id: number): Observable<ApiResponse<any>> {
        return this.apiService.postCall$<ApiResponse<any>>(`orderdirect-invoices/reset-status/${id}`, {});
    }
}
